var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7776 7.84723L19.1402 2.87639C19.0625 2.79339 18.9686 2.72723 18.8643 2.68198C18.7599 2.63674 18.6475 2.61338 18.5338 2.61335H11.6181L11.592 0.904624C11.592 0.475889 11.2208 0.12793 10.7635 0.12793C10.3062 0.12793 9.98681 0.475889 9.98681 0.904624L9.96157 2.61335H0.828474C0.370742 2.61335 0 2.98409 0 3.44182V13.3835C0 13.8412 0.370742 14.212 0.828474 14.212H9.95038V25.8624C9.95038 26.2911 10.3215 26.6391 10.7789 26.6391C11.2362 26.6391 11.6073 26.2911 11.6073 25.8624V14.212H18.5338C18.7637 14.212 18.9828 14.1167 19.1398 13.9489L23.7772 8.9781C24.0742 8.65955 24.0742 8.16578 23.7776 7.84723ZM18.1738 12.555H1.65692V4.2703H18.1738L22.0386 8.41267L18.1738 12.555Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreet);
export default __webpack_public_path__ + "static/media/street.73fc4d7f5ea491b4c022889e50280e34.svg";
export { ForwardRef as ReactComponent };